import ReactGA from "react-ga4";

const useAnalyticsEventTracker = (category="onda category") => {
  const eventTracker = (action = "test action", label = "test label") => {
    //console.log('=================================')
    //console.log({category, action, label})
    ReactGA.event({category, action, label});
  }
  return eventTracker;
}
export default useAnalyticsEventTracker;
